import { useCallback, useState } from "react";
import { clearReturningUser, getReturningUser, setReturningUser } from "../utils/returningUser.js";
export function useReturningUser() {
    const [data, setData] = useState(()=>getReturningUser());
    const save = useCallback((user)=>{
        setReturningUser(user);
        setData(user);
    }, []);
    const clear = useCallback(()=>{
        clearReturningUser();
        setData(null);
    }, []);
    return {
        data,
        save,
        clear
    };
}

//# sourceMappingURL=useReturningUser.js.map